export const OperacionCorporateFields = {
    CodPais: 'codPais',
    NombrePais: 'nombrePais',
    CodEstado: 'codOperacionCorporateEstado',
    CodSectorComercial: 'codSectorComercial',
    NombreSectorComercial: 'nombreSectorComercial',
    FechaAprobacion: 'fechaAprobacion',
    FechaVencimiento: 'fechaVencimiento',
    FechaAlta: 'fechaAlta',
    IdUsuarioAlta: 'idUsuarioAlta',
    Cuentas: 'cuentas',
    BitEnvio: 'enviar',
    PermiteEditar: 'permiteEditarOperacion',
    PermiteEliminar: 'permiteEliminarOperacion',
    NombreUsuarioAlta: 'nombreUsuarioAlta',
    ApellidoUsuarioAlta: 'apellidoUsuarioAlta',
    MailUsuarioAlta: 'mailUsuarioAlta'
} as const

export const OperacionCorporateCuentaFields = {
    NroCuenta: 'nroCuenta',
    RazonSocial: 'razonSocial',
    CodMoneda: 'codMoneda',
    DescMoneda: 'descMoneda',
    SimboloMoneda: 'simboloMoneda',
    Sector: 'descOperacionCorporateCuentaDetalleSeccion',
    Detalles: 'detalles',
    Importe: 'importe',
    ImporteConcertacion: 'importe_Concertacion',
    ImporteDPV: 'importe_DPV',
    ImporteFOP: 'importe_FOP',
    PermiteModificar: 'permiteModificar',
    Estilo: 'estilo',
} as const
